import { Controller } from "stimulus"
export default class extends Controller {
  static get targets(){
    return ['disableInnerWith'];
  }

  initialize(){
    let t = this;
    if (t.data.has('button-disable-with')){
      t.element.addEventListener('ajax:before', function(){
       t.data.set('original-html', t.disableElem().innerHTML) ;
       t.disableElem().innerHTML = t.data.get('button-disable-with');

      })

    }
   }

 
  new(e){
  if (this.data.has('original-html')) this.disableElem().innerHTML = this.data.get('original-html');
    this.renderForm(e.detail[0].response);
    var  modal = this.getModal();

    $(modal).modal('show');
    WebpackerReact.mountComponents(); 
    $(modal).on('hidden.bs.modal', function(){ 

      modal.querySelector('.modal-body').innerHTML = "";
      WebpackerReact.unmountComponents(); 


    })

    
  }

  onSubmitFail(e){
    this.renderForm(e.detail[2].response);
  }

  disableElem(){
    return    this.hasDisableInnerWithTarget ? this.disableInnerWithTarget : this.element;   

  }

  renderForm(response){
     let  modal = this.getModal(); 
    modal.querySelector('.modal-body').innerHTML = response;
  }

  getModal(){
    return document.getElementById(this.data.get("modal-id"));

  }

}
